"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styled_1 = require("@emotion/styled");
const theme_1 = require("../../theme");
const sidePadding = '8.625rem';
exports.StyledRegisterPanel = styled_1.default.section `
	max-width: 100%;
	padding: 2rem ${sidePadding};
	background-color: ${(props) => props.backgroundColour};

	.register-panel__flex-content {
		display: flex;
		flex-wrap: wrap;
	}

	.register-panel__heading {
		font-size: ${theme_1.default.typography.styles.a2.size};
		line-height: ${theme_1.default.typography.styles.a2.height};
		margin: ${theme_1.default.spacing.large} 0;
	}

	.register-panel__subheading {
		font-size: ${theme_1.default.typography.styles.a3.size};
		line-height: ${theme_1.default.typography.styles.a3.height};
		margin: ${theme_1.default.spacing.large} 0;
	}

	.register-panel__lhs-content {
		padding: ${theme_1.default.spacing.small} ${theme_1.default.spacing.default} ${theme_1.default.spacing.small} ${theme_1.default.spacing.small};
		flex-basis: 50%;
	}

	.register-panel__rich-text {
		font-size: ${theme_1.default.typography.styles.c1.size};
		line-height: ${theme_1.default.typography.styles.c1.height};
	}

	.register-panel__rich-text ul {
		list-style-type: none;
	}

	.register-panel__rich-text ul li::before {
		display: inline-block;
		width: 1.25rem;
		margin-left: -1.25rem;
		color: ${theme_1.default.colours.primary.default};
		content: '•';
	}

	.register-panel__rhs-content {
		padding: ${theme_1.default.spacing.small} ${theme_1.default.spacing.small} ${theme_1.default.spacing.small} ${theme_1.default.spacing.default};
		flex-basis: 50%;
		display: flex;
		justify-content: center;
	}

	.register-panel__register-iframe {
		height: 420px;
		max-width: 380px;
		background-color: #eeeeee;
		border-radius: ${theme_1.default.layout.radius.default};
		padding: ${theme_1.default.spacing.default};
	}

	.register-panel__cta-wrapper {
		text-align: center;
	}

	.register-panel__heading-separator {
		border-radius: 6.25rem;
		border: 2px solid #0D55B6;
		width: 3rem;
		margin: 0;
		position: relative;
		left: 0;
	}

	@media (max-width: 1024px) {
		padding: 4rem 0.5rem;

		.register-panel__heading {
			text-align: center;
		}

		.register-panel__subheading {
			text-align: center;
		}

		.register-panel__heading-separator {
			margin: 0 auto;
		}

		.register-panel__lhs-content {
			flex-basis: 100%;
			width: 100%;
			margin-bottom: ${theme_1.default.spacing.large};
			text-align: center;
		}

		.register-panel__rhs-content {
			flex-basis: 100%;
			width: 100%;
		}
	}

	.register-panel__cta-button {
		background-color: ${theme_1.default.colours.error.default};
		color: ${theme_1.default.colours.text.lightest};
		font-size: ${theme_1.default.typography.styles.c1.size};
		line-height: ${theme_1.default.typography.styles.c1.height};
		display: inline-flex;
		align-items: center;
		text-decoration: none;
		outline: none;
		position: relative;
		height: 40px;
		border: none;
		border-radius: 3.125rem;
		padding: ${theme_1.default.spacing.small} 2.875rem;
		overflow: hidden;
		opacity: 1;
		-moz-osx-font-smoothing: grayscale;
		-webkit-font-smoothing: antialiased;
		cursor: 'pointer';
		transition: background-color 0.4s ease-in 0s;
	}

	.register-panel__cta-button:hover {
		background-color: ${theme_1.default.colours.primary.default};
		color: ${theme_1.default.colours.text.lightest};
		text-decoration: none;
	}
`;
//# sourceMappingURL=register-panel.styled.js.map